module.exports = __webpack_public_path__ + "static/media/Maf_EmergenciaSanitaria_not.69f58686.jpg";